import React, { useRef } from "react";
import UnderlineSketch from "../DesignKit/UnderlineSketch";
import RoughBorder from "../LayoutKit/RoughBorder";

// hier stehen die Props
const ContactInfoCard = ({
  icon: Icon,
  title,
  actionLabel,
  onClick,
  children,
  color = "text-gray-900",
  className = "",
  actionClassName = "",
  gradient = "bg-gradient-to-br from-[#FAF6F1] to-[#F5EFE7]",
}) => {
  // Ref für RoughBorder
  const cardRef = useRef();

  return (
    <div
      ref={cardRef}
      className={`relative ${gradient} group rounded-xl p-6 flex flex-col items-center text-center font-mono text-sm cursor-pointer transition shadow-sm shadow-gray-900/10 hover:shadow-gray-900/20 duration-300 ease-in-out ${className}`}
      onClick={onClick}
      tabIndex={0}
      role="button"
      aria-label={`Klicke hier für ${title}`}
    >
      {/* Icon bleibt immer sichtbar, zentriert */}
      <Icon className={`text-xs sm:text-xl mb-2 z-10 transition-opacity duration-300 group-hover:opacity-0 ${color}`} />

      {/* Inhalt – wird beim Hover sanft ausgeblendet */}
      <div className="transition-opacity duration-500 group-hover:opacity-0 z-0">
        <p className="font-mono text-xs">{title}</p>
        <div className="text-gray-700">{children}</div>
      </div>

      {/* Hover-Aktion – erscheint sanft */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none z-20">
        <div className="opacity-0 group-hover:opacity-100 transition-opacity duration-500">
          <span className="relative z-10 flex items-center justify-center space-x-2">
            <span className="inline-block transform opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition duration-300">
              →
            </span>
            <span className="relative text-xs">
              {actionLabel}
              <span className="absolute left-0 -bottom-1 w-full h-[6px] pointer-events-none">
                <div className="origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-[900ms] ease-out delay-150">
                  <UnderlineSketch color="black" />
                </div>
              </span>
            </span>
          </span>
        </div>
      </div>

      {/* RoughBorder GANZ AUSSEN */}
      <RoughBorder
        parentRef={cardRef}
        radius={20}
        padding={2}
    color="#AC8E66" 
        strokeWidth={0.3}
        roughness={1}
        bowing={2}
      />
    </div>
  );
};

export default ContactInfoCard;
